<template>
<nav class="navbar" role="navigation" aria-label="main navigation">
  <div class="navbar-brand">
    <a class="navbar-item" href="https://github.com/gtalarico/grid-solver">
    <a class="navbar-item"
          href="/">
          <img src="@/assets/cube.png"
              width="25"
              height="25">
        </a>
    </a>

    <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>

  <div id="navbarBasicExample" class="navbar-menu">
    <div class="navbar-start">

        <span class="navbar-item is-size-6">
          Grid Solver
        </span>
    </div>
    <!--
    <div class="navbar-end">
      <div class="navbar-item">

        <span class="navbar-item made-for">
          <code>confidential</code>
        </span>
        <span class="navbar-item made-for">
          made for
        </span>
        <span class="navbar-item">
            <img src="@/assets/abb-60.png">
        </span>
      </div>
    </div>
    -->
  </div>
</nav>

</template>

<script>

export default {
  name: 'Navbar',
  data () {
    return {

    }
  },
  mounted () {

  },
  computed: {

  },
  methods: {

  }
}
</script>

<style lang="sass" scoped>

.navbar
  border-bottom: 1px solid #d6d6d6

  .made-for
    color: #aaa
    font-size: 0.9rem
    padding-right: 0

</style>
